import React from 'react'
import { Redirect } from 'react-router-dom'
import { MainLayout, Sidebar } from 'shared/ui'
import { getUserInfo } from 'shared/infrastructure/storage'
import { styled } from '@creditas-ui/react'
import { Routes } from 'config/routes'
import { Dashboard } from './Dashboard'

const View = styled.div`
  width: calc(100% - 94px);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
`

const DashboardContainer = () => {
  const user = getUserInfo().login.user.affiliateNameAlias
  const rootPathFiles = `https://assets.creditas.com/b2b-assets/1.0.0/dashboard-autonomos/`
  const paths = {
    AF231: 'programa-incentivos-autonomos-t1-af231-rios.pdf',
    AF223: 'programa-incentivos-autonomos-t1-af223-abrb.pdf',
    MF005: 'programa-incentivos-autonomos-t1-mf005-up4.pdf',
    AF128: 'programa-incentivos-autonomos-t1-af128-getcred.pdf',
    CN888: 'programa-incentivos-autonomos-t1-cn888-doze.pdf',
    AF336: 'programa-incentivos-autonomos-t1-af336-fenix.pdf',
    AF418: 'programa-incentivos-autonomos-t1-af418-arpoz.pdf',
    CN688: 'programa-incentivos-autonomos-t1-cn688-plus.pdf',
    AF699: 'programa-incentivos-autonomos-t1-af699-alfieri.pdf',
    tt001: 'programa-incentivos-autonomos-t1-mf005-up4.pdf',
    TT007: 'programa-incentivos-autonomos-t1-mf005-up4.pdf',
    cnpj2: 'programa-incentivos-autonomos-t1-mf005-up4.pdf',
    CB337: 'programa-incentivos-autonomos-t2-cb337-4m.pdf',
    CB398: 'programa-incentivos-autonomos-t2-cb398-facillit.pdf',
    MF013: 'programa-incentivos-autonomos-t2-mf013-jfm.pdf',
    GQ773: 'programa-incentivos-autonomos-t3-gq773-safira.pdf',
    GQ753: 'programa-incentivos-autonomos-t3-gq753-experato.pdf',
    GQ772: 'programa-incentivos-autonomos-t3-gq772-dmv.pdf',
    GQ826: 'programa-incentivos-autonomos-t3-gq826-safe.pdf',
    GQ815: 'programa-incentivos-autonomos-t3-gq815-supracor.pdf',
    AF309: 'programa-incentivos-autonomos-t3-af309-cn.pdf',
    GQ814: 'programa-incentivos-autonomos-t3-gq814-aplix.pdf',
    GQ805: 'programa-incentivos-autonomos-t3-gq805-tradicional.pdf',
    GQ816: 'programa-incentivos-autonomos-t3-gq816-conectta.pdf',
  }

  if (Object.keys(paths).includes(user) === false) {
    return <Redirect push to={Routes.Home} from={Routes.DashboardAutonomous} />
  }

  return (
    <>
      <MainLayout hasPadding={false}>
        <View>
          <Dashboard path={`${rootPathFiles}${paths[user]}`} />
        </View>
      </MainLayout>
    </>
  )
}

export { DashboardContainer }
